import { ILocumUserData } from '../auth/signIn.model';

export type ReferralLeaderboardMode = 'monthly' | 'overall';

export interface ReferralSummary {
  isEligible: boolean;
  referralCode: string;
  referralLink: string;
  points: number;
  referralCount: number;
  pendingReferralCount: number;
  qualifiedReferralCount: number;
  leaderboardRank: number | null;
}

export interface ReferralLeaderboardEntry {
  rank: number;
  email?: string;
  maskedEmail?: string;
  points: number;
  referralCount: number;
  avatarUrl?: string | null;
}

export interface ReferralSummaryResponse {
  data?: Partial<ReferralSummary>;
}

export const REFERRAL_AVATAR_BY_RANK: Record<number, string> = {
  1: '/static/img/referrals/avatar-1.jpg',
  2: '/static/img/referrals/avatar-2.jpg',
  3: '/static/img/referrals/avatar-3.jpg',
};

export type ReferralSummarySource = Partial<ReferralSummary> & {
  user?: ILocumUserData | null;
};
